import { render, staticRenderFns } from "./Devices2.vue?vue&type=template&id=b607d336"
import script from "./Devices2.vue?vue&type=script&lang=js"
export * from "./Devices2.vue?vue&type=script&lang=js"
import style0 from "./Devices2.vue?vue&type=style&index=0&id=b607d336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports